export default __webpack_public_path__ + "static/media/blogger.fa691251.svg";